import { gql } from '@urql/core';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { DEFAULT_LIMIT } from './constants';

export const adPlatformAnalyticsFeatureKeys = createQueryKeys('adPlatformAnalyticsFeature', {
  dashboard: ({ siteId, startAt, endAt, presetDate, platforms, limit }) => [
    {
      siteId,
      startAt,
      endAt,
      presetDate,
      platforms,
      limit,
    },
  ],
});

const adPlatformAnalyticsDocument = gql`
  query AdPlatformAnalytics(
    $siteId: Int!
    $startAt: Int
    $endAt: Int
    $presetDate: String
    $platforms: [AdPlatformSource!]
    $limit: Int
  ) {
    adPlatformAnalytics(
      siteId: $siteId
      startAt: $startAt
      endAt: $endAt
      presetDate: $presetDate
      platforms: $platforms
      limit: $limit
    ) {
      summary {
        impressions
        clicks
        spendMicros
        conversions
        conversionValueMicros
        roas
        ctr
        cpcMicros
        cpaMicros
      }
      daily {
        date
        impressions
        clicks
        spendMicros
        conversions
        conversionValueMicros
        roas
      }
      platformTotals {
        platform
        impressions
        clicks
        spendMicros
        conversions
        roas
      }
      topCampaigns {
        id
        platformId
        name
        platform
        impressions
        clicks
        spendMicros
        conversions
        roas
      }
      topAds {
        id
        platformId
        name
        platform
        impressions
        clicks
        spendMicros
        conversions
        roas
      }
      connections {
        connectionId
        accountId
        platform
        oldestImportedDataAt
        lastEntitiesSyncedAt
        lastMetricsSyncedAt
        lastSyncedAt
        lastSyncedDate
      }
    }
  }
`;

export function adPlatformAnalyticsQuery({ siteId, startAt, endAt, presetDate, platforms, limit = DEFAULT_LIMIT }) {
  const variables = {
    siteId,
    limit,
  };

  if (Number.isFinite(startAt)) variables.startAt = startAt;
  if (Number.isFinite(endAt)) variables.endAt = endAt;
  if (presetDate) variables.presetDate = presetDate;
  if (Array.isArray(platforms) && platforms.length > 0) variables.platforms = platforms;

  return {
    ...adPlatformAnalyticsFeatureKeys.dashboard({ siteId, startAt, endAt, presetDate, platforms, limit }),
    enabled: Number.isFinite(siteId),
    useErrorBoundary: false,
    refetchOnWindowFocus: false,
    meta: {
      query: adPlatformAnalyticsDocument,
      variables,
    },
  };
}
